import { useT } from '../../lib/i18n';

// Big Tipper pill — surfaces on client surfaces (profile header, alpha
// list row, cut-timer pickers) for clients in the top 10% of tippers
// on this barber's roster. Eligibility computed in client_stats
// (migration 0066) as `is_big_tipper = (tip_pct >= 0.90)` with a
// 3-tipped-visits floor.
//
// Visual class mirrors VIP/RevenueTierBadge: same shape and tracking,
// distinct color so it reads as a peer indicator. Green chosen for
// the "money in" connotation that lines up with how tips render
// elsewhere (chart overlay, cut-log per-row, TopMenuItems revenue).
//
// Per-user ranking: a low-tip-volume barber's "big tipper" floor is
// far lower than a high-end barber's. The badge always means "this
// client tips well FOR YOU," not an absolute threshold.

export function BigTipperBadge({
  size = 'sm',
  className = '',
}: {
  size?: 'sm' | 'md';
  className?: string;
}) {
  const t = useT();
  const sizing =
    size === 'sm'
      ? 'text-[10px] px-1.5 py-0.5 gap-1'
      : 'text-xs px-2 py-1 gap-1.5';
  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';
  return (
    <span
      className={`inline-flex items-center rounded font-semibold uppercase tracking-wide bg-green-600 text-white ring-1 ring-green-700 ${sizing} ${className}`}
      title={t('bigTipper.title')}
    >
      <DollarBadgeIcon className={iconSize} />
      {t('bigTipper.label')}
    </span>
  );
}

function DollarBadgeIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}
